import { render, staticRenderFns } from "./Breath.vue?vue&type=template&id=a69311fe&scoped=true&"
import script from "./Breath.vue?vue&type=script&lang=ts&"
export * from "./Breath.vue?vue&type=script&lang=ts&"
import style0 from "./Breath.vue?vue&type=style&index=0&id=a69311fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a69311fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFadeTransition,VRow})
